// A bundle's load page on Screen 8 (CR-004, J-185): what changes, then load or roll back. Rendered in
// the Data page's <Outlet/>; the admin only, as the Data page is. J-210: the page is told whether the
// caller holds every ACO, which a load needs.
import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";

import { BundleLoadPage } from "@/features/aco-data/components/bundle-load-page";
import { meAccessQueryOptions } from "@/features/auth/api/me-access";

export const Route = createFileRoute("/_authenticated/data/bundles/$bundleId/load")({
  staticData: { screenName: "Data" },
  component: LoadBundleRoute,
});

function LoadBundleRoute() {
  const { bundleId } = Route.useParams();
  const access = useQuery(meAccessQueryOptions());
  return <BundleLoadPage bundleId={bundleId} allAcos={access.data?.allAcos === true} />;
}
